import { render, staticRenderFns } from "./detailsByOrder.vue?vue&type=template&id=5f17aabd&"
import script from "./detailsByOrder.vue?vue&type=script&lang=js&"
export * from "./detailsByOrder.vue?vue&type=script&lang=js&"
import style0 from "./detailsByOrder.vue?vue&type=style&index=0&id=5f17aabd&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports